const NewPrivateChat = ({ className = '', ...props }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <rect width="36" height="36" rx="18" fill="currentColor" />
            <path
                d="M21.9642 10.5005L20.5 12.1671L12.1667 12.1671L12.1667 23.8338H23.8333V19.7684V15.703L25.5 14.0363V24.6671C25.5 24.8882 25.4122 25.1001 25.2559 25.2564C25.0996 25.4127 24.8877 25.5005 24.6667 25.5005L11.3333 25.5005C11.1123 25.5005 10.9004 25.4127 10.7441 25.2564C10.5878 25.1001 10.5 24.8882 10.5 24.6671L10.5 11.3338C10.5 11.1128 10.5878 10.9008 10.7441 10.7446C10.9004 10.5883 11.1123 10.5005 11.3333 10.5005L21.9642 10.5005ZM25.0725 9.26465L26.74 10.933L18 19.6675H16.3333V18.0008L25.0725 9.26465Z"
                fill="white"
            />
        </svg>
    );
};

export default NewPrivateChat;
